import { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { ADD_MATTER, MATTER_DETAILS, MATTER_STATUS, MATTERS_LIST, TEAM_LIST } from "../../global/API";
import { PulseLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../components/customModal/customModal";
import { Dropdown } from "primereact/dropdown";
import { formatDateTime, formatDateTimeShort, formatUSPhoneNumber, timeToSeconds } from "../../components/globalFunctions/globalFunctions";
import CustomChart from "../../components/customChart/customChart";
import { AuthContext } from "../../context/AuthContext/AuthContext";

function Matters() {
  const [matterList, setMatterList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paginationObj, setPaginationObj] = useState({ pageSize: 50, current: 1 });
  const [selectedMatters, setSelectedMatters] = useState([]);
  const [modifiedLeadDetails, setModifiedLeadDetails] = useState({});
  const [clioUserList, setClioUserList] = useState(null);
  const [matterStatusList, setMatterStatusList] = useState(null);
  const [getModalLayout, setGetModalLayout] = useState(null);
  const [viewMatter, setViewMatter] = useState([]);
  const [activityTab, setActivityTab] = useState("zoomInfo");
  const [zoomFilter, setZoomFilter] = useState("");
  const [filteredValues, setFilteredValues] = useState({ searchValue: "", assignedToValue: "", statusFilter: "", typeFilter: "", categoryFilter: "" });
  const { user } = useContext(AuthContext);

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue, assignedToValue, statusFilter, typeFilter, categoryFilter } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?limit=${pageSize}&page=${current}&search=${searchValue}&assignedto=${assignedToValue}&status=${statusFilter}&type=${typeFilter}&status_category=${categoryFilter}`;

    const URL = MATTERS_LIST + query;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setMatterList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAssignedToData = async () => {
    if (user?.role !== 1) return;
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?status=1`;
    const URL = TEAM_LIST + query;
    try {
      const response = await fetch(URL, options);
      const data = await response.json();
      if (data.status === "Success") {
        setClioUserList(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMatterStatusData = async () => {
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    const URL = MATTER_STATUS;
    try {
      const response = await fetch(URL, options);
      const data = await response.json();
      if (response.ok) {
        setMatterStatusList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onHandleEvent = (event, setFunction) => {
    const { name, value } = event.target;
    setFunction((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", selectedMatters[0]);
    formData.append("assignedto", modifiedLeadDetails.assignedto);

    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
      };
      const response = await fetch(ADD_MATTER + selectedMatters[0], options);
      const data = await response.json();

      if (data.status === "Success") {
        setSelectedMatters([]);
        fetchData(paginationObj.current, paginationObj.pageSize);
        navigate(`/matters`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const chartOverview = (data = viewMatter) => {
    const modifiedLeadData = data.map((lead) => {
      const inBound = { data: [], labels: [] };
      const outBound = { data: [], labels: [] };
      lead.client_zoom_calls.forEach((call) => {
        const seconds = timeToSeconds(call.duration);
        if (seconds <= 0) return;
        const label = `${formatDateTimeShort(call.start_time)}<br />Dur - ${call.duration}`;

        if (call.direction === "inbound") {
          inBound.data.push(seconds);
          inBound.labels.push(label);
        } else if (call.direction === "outbound") {
          outBound.data.push(seconds);
          outBound.labels.push(label);
        }
      });
      return { ...lead, inBoundChartData: inBound, outBoundChartData: outBound };
    });
    setViewMatter(modifiedLeadData);
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, [paginationObj]);

  useEffect(() => {
    fetchAssignedToData();
  }, []);

  useEffect(() => {
    fetchMatterStatusData();
  }, []);

  useEffect(() => {
    const { searchValue } = filteredValues;
    if (searchValue?.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  useEffect(() => {
    fetchData(1, paginationObj.pageSize);
  }, [filteredValues.assignedToValue, filteredValues.statusFilter, filteredValues.typeFilter, filteredValues.categoryFilter]);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedMatters((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedMatters.filter((item) => item !== id);
      setSelectedMatters(filteredListing);
    }
  };

  const mattersListView = () => {
    return matterList.data.map((matters) => {
      const { id, client_name, type, status, status_category, description, created_at, assignedto } = matters;
      const assignedToVal = clioUserList && clioUserList.filter((user) => user.id === assignedto)[0];

      return (
        <tr key={id}>
          <td>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedMatters.includes(id)} />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <button
              className="clio-name"
              onClick={() => {
                const existing = viewMatter.find((lead) => lead.id === id);
                if (!existing) {
                  const selectedMatter = matterList.data.find((matter) => matter.id === id);
                  setViewMatter((prevState) => [...prevState, selectedMatter]);
                  chartOverview([selectedMatter]);
                }
              }}
            >
              {client_name}
            </button>
          </td>
          <td>{type}</td>
          <td>{status}</td>
          <td>{assignedToVal ? `${assignedToVal?.name}` : "--"}</td>
          <td style={{ width: "400px" }}>
            <span className="item-overflow">{description}</span>
          </td>
          <td style={{ width: "250px" }}>{formatDateTime(created_at)}</td>
          <td>$0</td>
        </tr>
      );
    });
  };

  const mattersLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <PulseLoader color="#4180ad" />
        </td>
      </tr>
    );
  };

  const noMattersView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <a className="fs-28 avatar-title" style={{ lineHeight: "20px", marginBottom: "8px" }}>
            <i className="ri-file-warning-line"></i>
          </a>
          No Data Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return mattersLoadingView();
    } else if (matterList.status === "Not Found") {
      return noMattersView();
    } else if (matterList.status === "Error") {
      return noMattersView();
    } else if (matterList.status === "Success") {
      return mattersListView();
    }
  };

  const renderItem = () => {
    const { client_name, type, status, description, assignedto, primary_contact_phone_number, primary_contact_primary_email, status_category, lead_source_name } = modifiedLeadDetails;

    return (
      <form onSubmit={onHandleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input type="text" className="form-control" value={client_name} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Phone</label>
          <input type="text" className="form-control" value={primary_contact_phone_number} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input type="email" className="form-control" value={primary_contact_primary_email} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Assigned to</label>
          {user?.role === 1 ? (
            <Dropdown
              className="customDropdown"
              name="assignedto"
              value={assignedto}
              onChange={(e) => onHandleEvent(e, setModifiedLeadDetails)}
              options={clioUserList}
              optionValue="id"
              optionLabel="name"
              appendTo="self"
              placeholder="Select User"
            />
          ) : (
            <input type="text" className="form-control" value={lead_source_name} disabled />
          )}
        </div>
        <div className="mb-3">
          <label className="form-label">Status category</label>
          <input type="text" className="form-control" value={status_category} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Status</label>
          <input type="text" className="form-control" value={status} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Matter type</label>
          <input type="text" className="form-control" value={type} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Source</label>
          <input type="text" className="form-control" value={lead_source_name} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea type="text" className="form-control" value={description} disabled></textarea>
        </div>
        <div className="page-title-box">
          <button type="submit" className="btn btn-primary btn-blue">
            Submit
          </button>
        </div>
      </form>
    );
  };

  const handleReset = () => {
    setFilteredValues({ searchValue: "", assignedToValue: "", statusFilter: "", typeFilter: "", categoryFilter: "" });
    setSelectedMatters([]);
  };

  const leadFilters = () => {
    return (
      <div className="page-title-box-content">
        <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleReset}>
          <i className="ri-refresh-line"></i>
        </button>
        <div className="app-search">
          <select className="form-select" value={zoomFilter} onChange={(e) => setZoomFilter(e.target.value)}>
            <option value="">All</option>
            <option value="inbound">Inbound</option>
            <option value="outbound">Outbound</option>
            <option value="No Answer">No Answer</option>
          </select>
        </div>
      </div>
    );
  };

  const renderMatterDetails = (item) => {
    const {
      id,
      client_name,
      type,
      description,
      created_at,
      client_contact,
      status,
      status_category,
      client_zoom_calls,
      lead_source_name,
      Inbound,
      Outbound,
      Noanswer,
      Total_Calls,
      assignedto,
      inBoundChartData,
      outBoundChartData,
      notes,
    } = item;
    const assignedToVal = clioUserList && clioUserList.filter((user) => user.id === assignedto)[0];

    const filteredZoomCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction.includes(zoomFilter) || zoomCall.call_result.includes(zoomFilter));

    const clientCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction === "outbound");
    const inboundClientCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction === "inbound");

    const outProgressWidth = clientCalls.length === 0 ? "4px" : `${(clientCalls.length / 12) * 100}%`;
    const outBarColor = clientCalls.length === 0 ? "red" : clientCalls.length <= 4 ? "red" : clientCalls.length <= 8 ? "orange" : "green";
    const inProgressWidth = inboundClientCalls.length === 0 ? "4px" : `${(inboundClientCalls.length / 12) * 100}%`;
    const inBarColor = inboundClientCalls.length === 0 ? "red" : inboundClientCalls.length <= 4 ? "red" : inboundClientCalls.length <= 8 ? "orange" : "green";

    const OutTotal = Outbound > 12 ? Outbound : 12;
    const InTotal = Inbound > 12 ? Inbound : 12;
    const NoAnswer = Noanswer > 12 ? Noanswer : 12;
    const TotalCalls = Total_Calls > 12 ? Total_Calls : 12;

    const NoteCard = ({ subject, body, created_at }) => (
      <li className="note-item">
        <div className="note-meta">
          <strong className="note-subject">{subject || "Untitled"}</strong>
          {created_at && <span>{formatDateTime(created_at)}</span>}
        </div>
        <p className="note-text" style={{ margin: 0, whiteSpace: "pre-wrap" }}>
          {body || "--"}
        </p>
      </li>
    );
    const notesList = Array.isArray(notes) ? [...notes] : [];
    notesList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return (
      <>
        <div id="popupSidebar" className="popup-sidebar lead-sidebar">
          <ul>
            <li>
              <span>Name</span> {client_name}
            </li>
            <li>
              <span>Phone</span> {client_contact ? <a href={`tel:+1${client_contact}`}>{formatUSPhoneNumber(client_contact)}</a> : "--"}
            </li>
            <li>
              <span>Matters</span> {type}
            </li>
            <li>
              <span>Status</span> {status}
            </li>
            <li>
              <span>Assigned to</span> {assignedToVal ? `${assignedToVal?.name}` : "--"}
            </li>
            <li>
              <span>Source</span> {lead_source_name}
            </li>
            <li>
              <span>Created</span> {formatDateTime(created_at)}
            </li>
          </ul>
          <div className="des">
            <span>Description</span> <p>{description}</p>
          </div>

          {zoomFilter !== "No Answer" && (inBoundChartData?.data?.length > 0 || outBoundChartData?.data?.length > 0) && (
            <div className="des">
              {(zoomFilter === "inbound" || zoomFilter === "") && inBoundChartData?.data?.length > 0 && (
                <>
                  <span>Inbound Call Duration</span>
                  <div className="chart-grid">
                    <div className="chart-data">
                      <p>
                        {Inbound}/{InTotal}
                      </p>
                      <CustomChart chartLabels={inBoundChartData?.labels} chartDetails={inBoundChartData?.data} />
                    </div>
                    <ul className="chart-list">
                      <li>
                        <span>Total : </span>
                        {InTotal}
                      </li>
                      <li>
                        <span>Left : </span>
                        {InTotal - Inbound}
                      </li>
                      <li>
                        <span>Completed : </span>
                        {Inbound}
                      </li>
                    </ul>
                  </div>
                  <span>Inbound Call Progress</span>
                  <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "15px" }}>
                    <div style={{ width: "230px", height: "12px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                      <i
                        className="progress-bar-animate"
                        style={{
                          "--target-width": inProgressWidth,
                          "--bar-color": inBarColor,
                          display: "block",
                        }}
                      ></i>
                    </div>
                    <p style={{ marginBottom: "0" }}>
                      {inboundClientCalls.length}/{inboundClientCalls.length > 12 ? inboundClientCalls.length : 12}
                      {/* {filteredZoomCalls.length}/{filteredZoomCalls.length > 12 ? filteredZoomCalls.length : 12} */}
                    </p>
                  </div>
                </>
              )}
              {(zoomFilter === "outbound" || zoomFilter === "") && outBoundChartData?.data?.length > 0 && (
                <>
                  <span>Outbound Call Duration</span>
                  <div className="chart-grid">
                    <div className="chart-data">
                      <p>
                        {Outbound}/{OutTotal}
                      </p>
                      <CustomChart chartLabels={outBoundChartData?.labels} chartDetails={outBoundChartData?.data} />
                    </div>
                    <ul className="chart-list">
                      <li>
                        <span>Total : </span>
                        {OutTotal}
                      </li>
                      <li>
                        <span>Left : </span>
                        {OutTotal - Outbound}
                      </li>
                      <li>
                        <span>Completed : </span>
                        {Outbound}
                      </li>
                    </ul>
                  </div>
                  <span>Outbound Call Progress</span>
                  <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "15px" }}>
                    <div style={{ width: "230px", height: "12px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                      <i
                        className="progress-bar-animate"
                        style={{
                          "--target-width": outProgressWidth,
                          "--bar-color": outBarColor,
                          display: "block",
                        }}
                      ></i>
                    </div>
                    <p style={{ marginBottom: "0" }}>
                      {clientCalls.length}/{clientCalls.length > 12 ? clientCalls.length : 12}
                      {/* {filteredZoomCalls.length}/{filteredZoomCalls.length > 12 ? filteredZoomCalls.length : 12} */}
                    </p>
                  </div>
                </>
              )}
            </div>
          )}
          <div className="des des-list">
            <span>Call Information</span>
            <ul>
              <li>
                Inbound <span>{Inbound}</span>
              </li>
              <li>
                Outbound <span>{Outbound}</span>
              </li>
              <li>
                No Answer <span>{Noanswer}</span>
              </li>
            </ul>
          </div>
        </div>
        <div id="popupContentGrid" className="popup-content-grid">
          <div id="activitySidebar" className="activity-bar">
            {activityTab === "zoomInfo" && (
              <>
                <table className="table align-middle text-nowrap table-hover table-centered property-table ">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>From</th>
                      <th>To</th>
                      <th>Start Time</th>
                      <th>Duration</th>
                      <th>Recorded</th>
                      <th>Direction</th>
                    </tr>
                  </thead>

                  <tbody>
                    {(filteredZoomCalls || []).length > 0 ? (
                      filteredZoomCalls.map((call) => (
                        <tr key={call.id}>
                          <td>
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" />
                            </div>
                          </td>
                          <td className="capitalize">
                            {call.from_name ? <span className="clio-name">{call.from_name.toLowerCase()}</span> : ""}
                            <br />
                            <a href={`tel:+1${call.from_phone_number}`}>{formatUSPhoneNumber(call.from_phone_number)}</a> &nbsp; {call.from_ext ? <>Ext.{call.from_ext}</> : ""}
                          </td>
                          <td className="capitalize">
                            {call.to_name ? <span className="clio-name">{call.to_name.toLowerCase()}</span> : ""}
                            <br />
                            <a href={`tel:+1${call.to_phone_number}`}>{formatUSPhoneNumber(call.to_phone_number)}</a> &nbsp; {call.to_ext ? <>Ext.{call.to_ext}</> : ""}
                          </td>
                          <td>{formatDateTime(call.start_time)}</td>
                          <td>{call.duration || "--"}</td>
                          <td>{call.recorded === "y" ? "Yes" : "No"}</td>
                          <td>{call.direction}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No zoom call data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}
            {activityTab === "moreInfo" && (
              <div className="notes-wrap">
                <div className="notes-header">
                  <h4 style={{ margin: 0 }}>Notes ({notesList.length})</h4>
                </div>

                {notesList.length > 0 ? (
                  <ul className="notes-list">
                    {notesList.map((n) => (
                      <NoteCard key={n.id} subject={n.subject} body={n.body} created_at={n.created_at} />
                    ))}
                  </ul>
                ) : (
                  <div className="empty-notes" style={{ textAlign: "center", color: "#777", padding: "24px 8px" }}>
                    No notes found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="activity-bar-ribbon">
          <div className="activity-list">
            <button
              onClick={() => {
                setActivityTab("zoomInfo");
              }}
              className={`activityInfo-button fadeUp ${activityTab === "zoomInfo" ? "active" : ""}`}
              style={{ animationDelay: "0.5s" }}
            >
              <i className="ri-phone-fill"></i>
              <span>Calls</span>
            </button>
            <button
              onClick={() => {
                setActivityTab("moreInfo");
              }}
              className={`activityInfo-button fadeUp ${activityTab === "moreInfo" ? "active" : ""}`}
              style={{ animationDelay: "0.8s" }}
            >
              <i className="ri-add-line"></i>
              <span>Notes</span>
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">
                Matters <span>({matterList.pagination !== undefined ? matterList.pagination.total : 0})</span>
              </h4>

              <div className="page-title-box-content">
                <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleReset}>
                  <i className="ri-refresh-line"></i>
                </button>
                {selectedMatters.length === 1 && (
                  <button
                    type="button"
                    className="page-title-btn custom-target-icon fs-18"
                    onClick={() => {
                      navigate(`edit/${selectedMatters[0]}`);
                      const selectedMatterData = matterList.data.filter((matter) => matter.id === selectedMatters[0])[0];
                      setModifiedLeadDetails(selectedMatterData);
                    }}
                  >
                    <i className="ri-edit-2-line"></i>
                  </button>
                )}
                <div className="app-search">
                  <Dropdown
                    name="statusFilter"
                    value={filteredValues.statusFilter}
                    onChange={(e) => onHandleEvent(e, setFilteredValues)}
                    options={matterStatusList?.status}
                    filter
                    filterDelay={400}
                    optionValue="status"
                    optionLabel="status"
                    appendTo="self"
                    placeholder="Filter by Status"
                  />
                </div>
                <div className="app-search">
                  <Dropdown
                    name="typeFilter"
                    value={filteredValues.typeFilter}
                    onChange={(e) => onHandleEvent(e, setFilteredValues)}
                    options={matterStatusList?.type}
                    filter
                    filterDelay={400}
                    optionValue="type"
                    optionLabel="type"
                    appendTo="self"
                    placeholder="Filter by Type"
                  />
                </div>
                <div className="app-search">
                  <Dropdown
                    name="categoryFilter"
                    value={filteredValues.categoryFilter}
                    onChange={(e) => onHandleEvent(e, setFilteredValues)}
                    options={matterStatusList?.status_category}
                    optionValue="status_category"
                    optionLabel="status_category"
                    appendTo="self"
                    placeholder="Filter by category"
                  />
                </div>

                {user?.role === 1 ? (
                  <div className="app-search">
                    <Dropdown
                      name="assignedToValue"
                      value={filteredValues.assignedToValue}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      options={clioUserList}
                      optionValue="id"
                      optionLabel="name"
                      appendTo="self"
                      placeholder="Filter by assignee"
                    />
                  </div>
                ) : (
                  ""
                )}

                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedMatters(matterList.data.map((matter) => matter.id));
                              } else {
                                setSelectedMatters([]);
                              }
                            }}
                            checked={matterList?.data?.length > 0 && selectedMatters.length === matterList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Name</th>
                      <th>Matter Type</th>
                      <th>Status</th>

                      <th>Assigned to</th>
                      <th style={{ width: "400px" }}>Description</th>
                      <th style={{ width: "200px" }}>Created Date</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {matterList?.pagination?.total && (
          <div className="pagination-grid">
            <div className="pagination-new">
              <span className="pagination-count">
                {matterList.pagination !== undefined ? matterList.pagination.from : 1}-{matterList.pagination !== undefined ? matterList.pagination.to : 50} &nbsp;of &nbsp;
                {matterList.pagination !== undefined ? matterList.pagination.total : 0}
              </span>

              <button
                type="button"
                className="pagination-btn pagination-prev"
                onClick={() => {
                  setPaginationObj((prevState) => ({ ...prevState, current: prevState.current - 1 }));
                }}
                disabled={paginationObj.current === 1}
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                type="button"
                className="pagination-btn pagination-next"
                onClick={() => {
                  setPaginationObj((prevState) => ({ ...prevState, current: prevState.current + 1 }));
                }}
                disabled={paginationObj.current === matterList?.pagination?.last_page}
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        )}
        {selectedMatters.length === 1 && (
          <CustomModal renderItem={renderItem} title="Edit Matters" showHeader={true} position="right" visible={pathname.toLowerCase().includes(`edit/${selectedMatters[0]}`)} />
        )}
        <div className="minimize-grid">
          {viewMatter.length >= 1 &&
            viewMatter.map((item) => (
              <CustomModal
                key={item.id}
                renderItem={() => renderMatterDetails(item)}
                title="Lead Overview"
                secondaryTitle={item.client_name}
                getModalLayout={setGetModalLayout}
                visible={true}
                filters={leadFilters}
                showLeftSidebarIcon={true}
                showLayoutIcon={viewMatter.length === 1}
                onHandleClose={() => {
                  const modifiedData = viewMatter.filter((lead) => lead.id !== item.id);
                  setViewMatter(modifiedData);
                  handleReset();
                }}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default Matters;
